// new houseFeaturesDict
export const houseFeaturesDict = {
  PRIVATE_TOILET: '独卫',
  BALCONY: '带阳台',
  ELEVATOR: '电梯房',
  SMART_LOCK: '智能锁',
  FACE_SOUTH: '朝南',
  WIFI: 'wifi',
}
// old houseFeaturesDict
// export const houseFeaturesDict = {
//     AIR_CONDITIONER: '空调',
//     WIFI: 'wifi',
//     FACE_SOUTH: '朝南',
//     PARK: '停车场',
//     PRIVATE_BALCONY: '私人阳台',
//     DUAL_BALCONY: '双阳台',
//     PRIVATE_TOILET: '私人卫生间',

// }

// 与房间有关的枚举类型
export const houseFeatures = code => {
  return houseFeaturesDict[code] || ''
}

/**
 * @description 房源朝向枚举
 * @param {String} code
 */
export const houseDirection = code => {
  const dict = {
    EAST: '东',
    SOUTH: '南',
    WEST: '西',
    NORTH: '北',
    SOUTHEAST: '东南',
    NORTHEAST: '东北',
    SOUTHWEST: '西南',
    NORTHWEST: '西北',
  }
  return dict[code] || ''
}
/**
 * @description 房源类型 分租还是整租
 * @param {String} code 房源类型
 */

export const houseType = code => {
  const dict = {}
  return dict[code] || ''
}

/**
 * @description 厨房数量的枚举显示
 * @param {String} code
 */
export const kitchNumber = code => {
  const dict = {}
  return dict[code] || ''
}
/**
 * @description 卧室数量的枚举显示
 * @param {String} code
 */
export const bedroomNumber = code => {
  const dict = {}
  return dict[code] || ''
}

/**
 * @description 客厅数量的枚举显示
 * @param {String} code
 */
export const livingRoomNumber = code => {
  const dict = {}
  return dict[code] || ''
}
/**
 * @description 厕所数量的枚举显示
 * @param {String} code
 */
export const toiletNumber = code => {
  const dict = {}
  return dict[code] || ''
}

/**
 * 获取房源状态
 * @param {String} val
 */
export const houseSpaceStatus = function(val) {
  const dict = {
    WAIT_DELEGATE: '待托管',
    ASSESSING: '评估中',
    APPROVED: '审核通过',
    SIGNING_DC: '签订托管合同中',
    DC_NOT_TE: '已托管合同未生效',
    DC_TE: '已托管合同已生效',
    DESIGNING: '设计中',
    CONSTRUCTING: '施工中',
    CHECKING: '验收中',
    RETAIN: '保留',
    TO_BE_RUN: '待运营',
    RENTABLE: '空置',
    RESERVED: '已预订',
    SIGNING_LC: '签订租赁合同中',
    LC_NOT_TE: '合同未生效',
    RENTED: '已出租',
    FREEZING: '已冻结',
    DELETED: '已删除',
    TRANSFORM: '已转换(分拆合并)',
  }

  return dict[val]
}

/**
 * @description 装修类型
 * @param {*} val
 */
export const decorateType = function(val) {
  const dict = {
    R: '毛坯房',
    S: '简装',
    RD: '精装',
    A: '豪华装修',
  }
  return dict[val] || val
}

export const houseSpacePurposeType = val => {
  const dict = {
    SAMPLE: '样板房',
    IDLE: '闲置房',
    RESERVE: '留用房',
    RENTAL: '出租房',
  }
  return dict[val] || val
}

export const houseSpaceManagerTypes = val => {
  let dict = {
    C_PARENT_HOUSE: '集中式房源代表项目',
    HOUSE: '房间',
    STORE: '商铺',
    OFFICE_BUILDING: '办公位',
    HOTEL: '酒店',
    HOMESTAY: '民宿',
    CABINET: '橱柜',
    CARD: '一卡通',
    CARPORT: '车位',
  }
  return dict[val] || val
}

export default {
  houseFeaturesDict,
  houseFeatures,
  houseDirection,
  houseType,
  livingRoomNumber,
  kitchNumber,
  bedroomNumber,
  toiletNumber,
}

// s-date 时间格式过滤
export const changeTimeType = val => {
  if (!val) {
    return ''
  }
  var timer = val
  timer = new Date(timer)
  // console.log(timer)
  const year = timer.getFullYear()
  var month = timer.getMonth() + 1
  month = month < 10 ? '0' + month : month
  var date = timer.getDate()
  date = date < 10 ? '0' + date : date
  const stringTime = year + '-' + month + '-' + date
  return stringTime
}
// 房间内物品配置对应枚举
export const optionList = [
  {
    id: 'airConditionerNum',
    name: '空调',
  },
  {
    id: 'bedNum',
    name: '床',
  },
  {
    id: 'bedTableNum',
    name: '床头柜',
  },
  {
    id: 'bookSelfNum',
    name: '书架',
  },
  {
    id: 'chairNum',
    name: '椅子',
  },
  {
    id: 'deskNum',
    name: '桌子',
  },
  {
    id: 'gasStoveNum',
    name: '燃气灶',
  },
  {
    id: 'inductionCookerNum',
    name: '电磁炉',
  },
  {
    id: 'rangeHoodNum',
    name: '油烟机',
  },
  {
    id: 'refrigeratorNum',
    name: '冰箱',
  },
  {
    id: 'tableLampNum',
    name: '台灯',
  },
  {
    id: 'tvNum',
    name: '电视',
  },
  {
    id: 'wardrobeNum',
    name: '衣柜',
  },
  {
    id: 'washingMachineNum',
    name: '洗衣机',
  },
  {
    id: 'waterHeaterNum',
    name: '热水器',
  },
]
// 房间特色对应枚举
export const featureList = [
  {
    id: 'SMART_LOCK',
    name: '智能门锁',
  },
  {
    id: 'WIFI',
    name: 'Wi-Fi',
  },
  {
    id: 'FACE_SOUTH',
    name: '朝南',
  },
  {
    id: 'BALCONY',
    name: '私人阳台',
  },
  {
    id: 'ELEVATOR',
    name: '电梯房',
  },
  {
    id: 'PRIVATE_TOILET',
    name: '独卫',
  },
]
export const spaceManagerList = [
  {
    id: null,
    name: '类别',
  },
  {
    id: 'HOTEL',
    name: '酒店',
  },
  {
    id: 'CABINET',
    name: '橱柜',
  },
  {
    id: 'CARD',
    name: '一卡通',
  },
  {
    id: 'CARPORT',
    name: '车位',
  },
]



// WEBPACK FOOTER //
// ./src/filters/modules/house.js